var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { store } from '../../../../store/store';
import { pushConsoleError, setErrorTracking, setSmartRooms, } from '../../../../store/uislice';
import { DataService } from '../../../configure/service/deviceservice';
import { Constants } from '../../../configure/models/constants';
import { getRichMapScriptCandidates, resolveRichMapScriptUrl, } from './rich-maps-loader';
export const STATUSES = {
    AVAILABLE: 'Available',
    BOOKED: 'Booked',
    OCCUPIED: 'Occupied',
    OCCUPIED_BOOKED: 'Occupied',
    HOLD: 'Hold',
};
export const STATUS_COLOR_MAP = {
    Available: '#71FF31',
    Booked: '#FF8F54',
    Occupied: '#FCA5B8',
    Occupied_booked: '#FCA5B8',
    Hold: '#2196f3',
};
export function vwToPixels(vw) {
    return (vw / 100) * window.innerWidth;
}
export function compareName(room1, room2) {
    const name1 = room1.name.toUpperCase();
    const name2 = room2.name.toUpperCase();
    let comparison = 0;
    if (name1 > name2) {
        comparison = 1;
    }
    else if (name1 < name2) {
        comparison = -1;
    }
    return comparison;
}
export const available = '#4D7E3A';
export const availableBorder = '#71FF31';
export const booked = '#8B390E';
export const bookedBorder = '#FF8F54';
export const occupied = '#A5314B';
export const occupiedBorder = '#FCA5B8';
export const noData = '#1f2226';
export const noDataBorder = '#678087';
export const hold = '#2196f3';
export const holdBorder = '#00bceb';
export const getBgColorByStatus = (status = '') => {
    if (status === STATUSES.AVAILABLE)
        return available;
    if (status === STATUSES.BOOKED)
        return booked;
    if (status === STATUSES.OCCUPIED)
        return occupied;
    if (status === STATUSES.OCCUPIED_BOOKED)
        return occupied;
    if (status === STATUSES.HOLD)
        return hold;
    return noData;
};
export const getBorderColorByStatus = (status = '') => {
    if (status === STATUSES.AVAILABLE)
        return availableBorder;
    if (status === STATUSES.BOOKED)
        return bookedBorder;
    if (status === STATUSES.OCCUPIED)
        return occupiedBorder;
    if (status === STATUSES.OCCUPIED_BOOKED)
        return occupiedBorder;
    if (status === STATUSES.HOLD)
        return holdBorder;
    return noDataBorder;
};
export const availabilityStatusColorMap = {
    Available: '#6abf4b',
    Occupied: '#a5314b',
    Booked: '#8f542a',
    Hold: '#2196f3',
    Unknown: '',
};
export const availabilityStatusBorderMap = {
    Available: '#71ff31',
    Occupied: '#fCa5b8',
    Booked: '#f08130',
    Hold: '#00bceb',
    Unknown: '#787878',
};
// Constants, no localization needed
export const POI_TYPES = [
    'Rest Rooms',
    'Cafeteria',
    'Help Desk',
    'Child Care Area',
    'Stairs',
    'Elevators',
];
// Constants, no localization needed
export const POIS_MAP = {
    'Rest Rooms': 'toilets',
    Cafeteria: 'restaurant',
    'Help Desk': 'help-desk',
    'Child Care Area': 'child-care',
    Stairs: 'stairs',
    Elevators: 'lift',
};
export const POI_TYPES_ORIGINAL = [
    'toilets',
    'restaurant',
    'help-desk',
    'child-care',
    'stairs',
    'lift',
];
const PORTAL_NAME_TRANSLATION_KEYS = {
    elevator: 'floor.directions.elevator',
    elevators: 'floor.directions.elevators',
    stair: 'floor.directions.stairs',
    stairs: 'floor.directions.stairs',
};
export const getLocalizedPortalName = (portalName, t) => {
    const fallbackPortalName = t('floor.directions.elevator');
    const value = (portalName === null || portalName === void 0 ? void 0 : portalName.trim()) || fallbackPortalName;
    const match = value.match(/^(elevators?|stairs?)(\b.*)?$/i);
    if (!match) {
        return value;
    }
    const translationKey = PORTAL_NAME_TRANSLATION_KEYS[match[1].toLowerCase()] ||
        PORTAL_NAME_TRANSLATION_KEYS.elevator;
    return `${t(translationKey)}${match[2] || ''}`;
};
export const smartRoomsCall = (tenantId) => __awaiter(void 0, void 0, void 0, function* () {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const urlString = `${origin}/smart_rooms/${tenantId}/${tenantId}.json`;
    yield axios({ url: urlString, method: 'GET' })
        .then((res) => {
        store.dispatch(setSmartRooms({ payload: res.data }));
    })
        .catch(() => {
        store.dispatch(setSmartRooms({ payload: ['error'] }));
    });
});
export const getFloorNumberIdMap = (locationData) => {
    var _a;
    const floorNumberIdMap = {};
    for (const floorNumber of (_a = locationData === null || locationData === void 0 ? void 0 : locationData.children) !== null && _a !== void 0 ? _a : []) {
        floorNumberIdMap[floorNumber.floorNumber] = floorNumber.id;
    }
    return floorNumberIdMap;
};
export const resolveActiveFloorLocation = (locationData, contextInfo, preferredFloorId = '') => {
    var _a, _b, _c, _d, _e, _f;
    const children = (_a = locationData === null || locationData === void 0 ? void 0 : locationData.children) !== null && _a !== void 0 ? _a : [];
    if (children.length === 0) {
        return {
            floorLocationId: '',
            floorLocationData: undefined,
        };
    }
    const findFloorById = (id) => id ? children.find((child) => child.id === id) : undefined;
    const floorLocationData = (_e = (_d = (_c = (_b = findFloorById(preferredFloorId)) !== null && _b !== void 0 ? _b : findFloorById(contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.currentLocationGraphId)) !== null && _c !== void 0 ? _c : findFloorById(contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.deviceLocationId)) !== null && _d !== void 0 ? _d : children.find((child) => (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.floorNumber) !== undefined &&
        (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.floorNumber) !== null &&
        Number(child.floorNumber) === Number(contextInfo.floorNumber))) !== null && _e !== void 0 ? _e : children[0];
    return {
        floorLocationId: (_f = floorLocationData === null || floorLocationData === void 0 ? void 0 : floorLocationData.id) !== null && _f !== void 0 ? _f : '',
        floorLocationData,
    };
};
export const getFloorShortNameByNumber = (locationData, floorNumber) => {
    var _a;
    const normalizedFloorNumber = Number(floorNumber);
    const floor = (_a = locationData === null || locationData === void 0 ? void 0 : locationData.children) === null || _a === void 0 ? void 0 : _a.find((child) => Number(child.floorNumber) === normalizedFloorNumber);
    return (floor === null || floor === void 0 ? void 0 : floor.shortName) || String(floorNumber !== null && floorNumber !== void 0 ? floorNumber : '');
};
export const floorStatusByPercentage = (percentage) => {
    if (percentage < 20)
        return 'Very Low';
    if (percentage < 40)
        return 'Low';
    if (percentage < 60)
        return 'Busy';
    if (percentage < 80)
        return 'Very Busy';
    if (percentage >= 80)
        return 'Crowded';
    return 'no-data';
};
export const getOccupancyStatus = (peopleCount, capacity) => {
    const occupancyPercentage = (peopleCount * 100) / capacity;
    const percentage = peopleCount <= capacity ? occupancyPercentage : 100;
    const floorStatus = floorStatusByPercentage(occupancyPercentage);
    return floorStatus;
};
export const sendAlertToServer = ({ name, severity }, error) => __awaiter(void 0, void 0, void 0, function* () {
    const errorTrackingFlag = store.getState().UI.errorTrackingEnabled;
    // Do not send alerts when error tracking is disabled
    if (!errorTrackingFlag)
        return;
    const dataService = new DataService();
    const payload = {
        domain: window.location.hostname,
        error: {
            msg: error
                ? error
                    .replace(/\\"/g, '"')
                    .replace(/"/g, '')
                    .replace(/[{}]/g, '')
                    .replace(/'/g, '')
                : 'Unknown',
        },
        errorType: name ? name : Constants.ALERTS.UNKNOWN_ERROR,
        severity: severity,
        meta: {
            timeStamp: Math.floor(Date.now() / 1000),
            tenant: dataService.getTenantId(),
            token: dataService.getDeviceToken(),
            userAgent: navigator.userAgent,
        },
    };
    fetch(`https://${window.location.hostname}/v1/console/log`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Workspaces-Device-Token': dataService.getDeviceToken(),
            'User-Agent': navigator.userAgent,
        },
        body: JSON.stringify(payload),
    });
    if (severity === 'fatal') {
        sendLogsToServer();
        // The SIGNAGE_2_1_SUCCESS heartbeat reuses the 'fatal' path so it is
        // recorded and dumps logs, but it is a success signal (not an error) and
        // must NOT disable error tracking for the rest of the session.
        if (name !== Constants.ALERTS.SIGNAGE_2_1_SUCCESS.name) {
            // Stop error tracking, once a fatal error is received
            store.dispatch(setErrorTracking({ payload: false }));
        }
    }
});
export const sendLogsToServer = (requestId) => __awaiter(void 0, void 0, void 0, function* () {
    const dataService = new DataService();
    const signageToken = dataService.getDeviceToken();
    const tenantMaskId = dataService.getTenantIdMasked();
    const deviceId = dataService.getDeviceId();
    const orgId = dataService.getOrgId();
    const isNav = dataService.getIsNavigator();
    const tenantId = dataService.getTenantId();
    const state = store.getState();
    const consoleErrorLogs = state.UI.consoleErrors;
    console.log('Sending console errors to server :: ', consoleErrorLogs);
    fetch(`https://${window.location.hostname}/v1/serverRequestedLog?requestId=${requestId}&signageToken=${signageToken}&tenantMaskId=${tenantMaskId}&deviceId=${deviceId}&orgId=${orgId}&isNav=${isNav}&tenantId=${tenantId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'text/plain',
        },
        body: JSON.stringify(consoleErrorLogs) +
            '\n' +
            'requestID : ' +
            requestId +
            '\n' +
            'signageToken : ' +
            signageToken +
            '\n' +
            'tenantMaskId : ' +
            tenantMaskId +
            '\n' +
            'deviceId : ' +
            deviceId +
            '\n' +
            'orgId : ' +
            orgId +
            '\n' +
            'isNav : ' +
            isNav,
    });
});
export const catchErrorsForAlerts = () => {
    if (typeof window === 'undefined')
        return;
    const w = window;
    // Install once. Without this guard, a repeat call (React StrictMode double
    // effect, remount) wraps console.error in additional layers, so every error
    // fans out into N dispatches + N network POSTs.
    if (w.__catchErrorsForAlertsInstalled)
        return;
    w.__catchErrorsForAlertsInstalled = true;
    const originalConsoleError = console.error;
    console.error = (...args) => {
        store.dispatch(pushConsoleError({ payload: JSON.stringify(args) }));
        sendAlertToServer(Constants.ALERTS.CLIENT_ERROR, JSON.stringify(args));
        originalConsoleError.apply(console, args);
    };
    window.addEventListener('error', (e) => {
        store.dispatch(pushConsoleError({ payload: JSON.stringify(e) }));
        sendAlertToServer(Constants.ALERTS.CLIENT_ERROR, JSON.stringify(e));
    });
};
let richMapsLoadPromise = null;
const loadRichMapsInternal = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    //@ts-ignore
    function loadJS(script_url, async = true) {
        return new Promise((resolve, reject) => {
            let dyn_spt_ele = document.createElement('script');
            dyn_spt_ele.setAttribute('src', script_url);
            dyn_spt_ele.setAttribute('type', 'text/javascript');
            //@ts-ignore
            dyn_spt_ele.setAttribute('async', async);
            //Trying to capture more details for script error
            dyn_spt_ele.setAttribute('crossorigin', 'anonymous');
            document.body.appendChild(dyn_spt_ele);
            // success event
            dyn_spt_ele.addEventListener('load', () => {
                console.log('script file loaded.');
                resolve();
            });
            // error event
            dyn_spt_ele.addEventListener('error', ($event) => {
                console.log('error on loading script file.', $event);
                dyn_spt_ele.remove();
                reject($event);
            });
        });
    }
    var lang = navigator.language; //no ?s necessary
    console.log('Language');
    console.log(lang);
    const searchParams = new URLSearchParams(window.location.search);
    console.log(searchParams.get('domain'));
    let hostname = window.location.hostname;
    console.log('hostname', hostname);
    let endpoint_url = searchParams.get('domain') != null ? searchParams.get('domain') : hostname;
    console.log('endpoint_url', endpoint_url);
    let domainName = 'dev-dnaspaces.io';
    let matches = endpoint_url === null || endpoint_url === void 0 ? void 0 : endpoint_url.match(/^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/);
    if (matches &&
        matches.length > 1 &&
        endpoint_url !== null &&
        !endpoint_url.includes('webex-api-server-test')) {
        domainName = matches[1];
        console.log('domainName', domainName);
    }
    const domainToUse = window.location.hostname.includes('localhost')
        ? 'dev-dnaspaces.io'
        : location.host.split('.')[1] + '.' + location.host.split('.')[2];
    const richmapFilename = (_a = searchParams.get('richmap_filename')) !== null && _a !== void 0 ? _a : 'rich-maps-0.1.5.5.js';
    const params = new URLSearchParams(window.location.search);
    const domainParam = params.get('domain');
    let richMapUrls = getRichMapScriptCandidates(domainToUse, richmapFilename);
    if (domainParam === null || domainParam === void 0 ? void 0 : domainParam.includes('swe-api-server')) {
        richMapUrls = ['//rms.' + 'dev-dnaspaces.io' + '/js/' + richmapFilename];
    }
    if (searchParams.get('rms') != null) {
        richMapUrls = [(_b = searchParams.get('rms')) !== null && _b !== void 0 ? _b : richMapUrls[0]];
    }
    const richMapUrl = yield resolveRichMapScriptUrl(richMapUrls);
    console.log('richMapUrl', richMapUrl);
    // Load the 3D map asset scripts (THREE + GLTFLoader) from the region-matched
    // host before the rich maps SDK. These MUST be present as globals before the
    // SDK loads (and before `new RichMap()`), otherwise the SDK throws
    // "THREE is not defined" / "Cannot read properties of undefined (reading
    // 'Camera')". Loading them here (promise-based, in order, awaited) guarantees
    // that ordering without relying on document.write, which Chrome de-prioritizes
    // for cross-origin, parser-inserted scripts.
    try {
        const assetTld = (hostname.split('.').pop() || 'io').toLowerCase();
        const assetBase = assetTld === 'eu'
            ? 'https://maps.ciscospaces.eu'
            : assetTld === 'sg'
                ? 'https://maps.ciscospaces.sg'
                : 'https://maps.ciscospaces.io';
        if (typeof window.THREE === 'undefined') {
            yield loadJS(assetBase + '/js/three.min.js', false);
            yield loadJS(assetBase + '/js/GLTFLoader.js', false);
        }
    }
    catch (assetError) {
        console.log('Error loading 3D map asset scripts.', assetError);
    }
    try {
        yield loadJS(richMapUrl, false);
    }
    catch (error) {
        const fallbackUrl = richMapUrls[1];
        if (fallbackUrl && fallbackUrl !== richMapUrl) {
            console.log('Retrying rich maps script with fallback URL.', fallbackUrl);
            yield loadJS(fallbackUrl, false);
        }
        else {
            throw error;
        }
    }
    if (!hostname.includes('localhost')) {
        (function (apiKey) {
            (function (p, e, n, d, o) {
                var v, w, x, y, z;
                o = p[d] = p[d] || {};
                //@ts-ignore
                o._q = [];
                v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
                for (w = 0, x = v.length; w < x; ++w)
                    (function (m) {
                        //@ts-ignore
                        o[m] =
                            //@ts-ignore
                            o[m] ||
                                function () {
                                    //@ts-ignore
                                    o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
                                };
                    })(v[w]);
                y = e.createElement(n);
                y.async = !0;
                y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
                z = e.getElementsByTagName(n)[0];
                z.parentNode.insertBefore(y, z);
                console.log('Pendo script loaded successfully....');
            })(window, document, 'script', 'pendo');
        })('38f881a7-bc46-4b50-69ff-f2b3894e0bb2');
        // function loadGuides() {
        //   setTimeout(() => {
        //     try {
        //       if (pendo) {
        //         pendo.setGuidesDisabled(true);
        //         pendo.loadGuides();
        //       } else {
        //         loadGuides();
        //       }
        //     } catch (e) {
        //       console.log(e);
        //       loadGuides();
        //     }
        //   }, 1000);
        // }
        // loadGuides();
    }
});
export const loadRichMaps = () => {
    if (!richMapsLoadPromise) {
        richMapsLoadPromise = loadRichMapsInternal().catch((error) => {
            // Allow a later mount to retry after a transient loading failure.
            richMapsLoadPromise = null;
            throw error;
        });
    }
    return richMapsLoadPromise;
};
function sendTrackingEvent(eventType, featureName = 'Unknown', properties = {}, tenantId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const data = {
                type: 'track',
                event: `SpacesEvents - Digital Signage`,
                visitorId: `user_${tenantId}_${window.location.href.split('/')[2]}`,
                accountId: `${tenantId}_${window.location.href.split('/')[2]}`,
                timestamp: Date.now(),
                properties: Object.assign(Object.assign({}, properties), { eventType: eventType, featureName: featureName }),
                context: {
                    ip: '',
                    userAgent: window.navigator.userAgent,
                    url: window.location.href,
                    title: window.document.title, // Current page title
                },
            };
            const response = yield fetch('https://app.pendo.io/data/track', {
                method: 'POST',
                headers: {
                    'x-pendo-integration-key': '1186bfe2-77b2-4fba-4b39-b46e29279f20',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify(data),
            });
            if (!response.ok) {
                console.error(`HTTP error! status: ${response.status}`);
            }
            const responseData = yield response.json();
            console.log('Pendo Event Tracked Successfully:', responseData);
        }
        catch (error) {
            console.error('Error tracking Pendo event:', error);
        }
    });
}
export function sendTrackingEventForMapClick(feature, tenantId) {
    sendTrackingEvent('MapClick', feature, undefined, tenantId);
}
export function sendTrackingEventForGetDirectionsClick(feature, tenantId) {
    sendTrackingEvent('GetDirectionsClick', feature, undefined, tenantId);
}
export function sendTrackingEventForZoomChange(zoomValue, tenantId) {
    const zoomLevel = zoomValue || 'Unknown';
    sendTrackingEvent('MapZoomChange', zoomLevel, undefined, tenantId);
}
